import React, { useState, useEffect } from 'react';
import PageTitle from '../common/PageTitle';
import { Container, Row, Col } from "shards-react";
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import axios from 'axios';
import api from '../common/api';
import ConfirmDialog from '../common/ConfirmDialog';
const useStyles = theme => ({
    root: {
      flexGrow: 1,
      width: '100%',
    },
      appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: '2rem',
      flex: 1,
      color: 'white'
    },
    paper: {
      padding: '2rem',
      textAlign: 'center',
    },
    checkedIcon:{
        width: 16,
        height: 16,
    },
    option:{
          fontWeight: 600,
        fontSize:'0.75rem',
    },
    typography:{
        fontSize: '0.75rem'
    },
    select:{
        marginTop: '0',
        marginRight:'12px',
        padding: '0'
    },
    menu:{
        fontSize: '0.75rem'
    }
  });
  
function PushNotificationComponent(props) {
    const [users, setUsers] = useState({})
    const [notification, setNotification] = useState({title:'', body: ''})
    const [loading, setLoading] = useState(true)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [error, setError] = useState(false)
    const [errors, setErrors] = useState({})

    const sendNotification = async () => {
		const token = localStorage.getItem('userToken')
        var formData = new FormData();
        var i = 0;
        users.forEach(element => {
            formData.set('users['+i+'][id]', element.id)
            i++;
        });
        formData.set('title', notification.title)
        formData.set('body', notification.body)
        axios.post(api.pushNotification,
                formData,
                {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
                )
				.then((response)=> {
                    setError(false)
                    setDialogOpen(true)
                })
				.catch(function (error) {
                    var promise = new Promise(function(resolve, reject) {
                        resolve(error.response.data);
                        setErrors( error.response.data)
                    });
                    setError(true)
                    setDialogOpen(true)
				})
        
    }
    const getUsers = async (id) => {
		const token = localStorage.getItem('userToken')
		return await axios.get(api.users().get(id),
				{headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
				)
				.then((response)=> {
				    setUsers(response.data)
                    setLoading(false)
				})
				.catch(function (error) {
					console.log(error)
				})

    }

    const handleRedirect = () => {
        setDialogOpen(false)        
        props.onRedirect();
    }
    useEffect(()=>{
        const id = props.user_id;
        getUsers(id)
    },[])
	return (
        <>
            <Row>
            <ConfirmDialog 
                confirm_dialog={dialogOpen} 
                title={"Enviar notificación"}
                message={(!errors.errors) ? "Se envió la notificación con éxito." : "Ha ocurrido un error"}
                onClose={()=>{setDialogOpen(false)}} 
                onAccept={()=>{handleRedirect()}}
                onCancel={()=>{setDialogOpen(false)}}
                errors={errors}
            
            />                
            {!loading && 
                <Col md="12">
                    <React.Fragment>
                        <TextField
                            id="name"
                            value={users.map(u => u.name).join(', ')}                             disabled
                            fullWidth
                            type="text"
                            name="name"
                            margin="normal"
                            className="m-0 p-0 mr-2"
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" ><Typography variant="caption">Nombre</Typography></InputAdornment>,
                            }}
                        />	
                        <TextField
                            id="email"
                            value={users.map(u => u.email).join(', ')}                             disabled
                            fullWidth
                            type="text"
                            name="email"
                            margin="normal"
                            className="m-t-2 p-0 mr-2"
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" ><Typography variant="caption">Email</Typography></InputAdornment>,
                            }}
                        />	
                        <TextField
                            id="title"
                            value={notification.title}
                            fullWidth
                            type="text"
                            name="title"
                            margin="normal"
                            onChange={(value)=>{setNotification({...notification, title: value.target.value})}}
                            className="m-t-2 p-0 mr-2"
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" ><Typography variant="caption">Titulo</Typography></InputAdornment>,
                            }}
                        />	
                        <TextareaAutosize
                            id="body"
                            name="body"
                            margin="normal"
                            InputProps={{
                                startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{minWidth: 50}}>Cuerpo </Typography></InputAdornment>,
                            }}
                            minRows={5}
                            placeholder="Agregue descripción de la notificación"
                            className="mr-2 mt-0"
                            InputLabelProps={{
                                shrink: true
                            }}
                            onChange={(value) =>
                                setNotification({ ...notification, body: value.target.value })
                            }
                            value={notification.body}
                            style={{ width: '100%', fontSize: '0.75rem'}}
                        />                

                        <Button className="mt-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={()=>{sendNotification()}}>Enviar</Button>
                        <Button className="mt-2 ml-2" variant="contained" color="secondary" size="small" style={{fontSize: '0.75rem'}} href={'/mobile/users'}>Volver</Button>

                    </React.Fragment>
                </Col>
            }
        </Row>
    </>
	)

}

export default withStyles(useStyles)(PushNotificationComponent);
